import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";

@Component({
  selector: 'app-select-currency',
  templateUrl: './select-currency.component.html',
  styleUrls: ['./select-currency.component.scss']
})
export class SelectCurrencyComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: any;
  currency = [];
  searchCurrency = "";

  @ViewChild("currencyModalContent") private currencyModalContent: ElementRef;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.currency = this.dataService.currencyList;
  }

  selectCurrency(currencycode,currencyname,currencydialcode) {
    this.dataService.selectedCurrencyName = currencyname;
    this.dataService.selectCurrencyCode = currencycode;
    this.dataService.selectCurrencyDial = currencydialcode;
    this.dataService.currencyPlaceholder = false;
    this.closeModal();
  }
  private filterCurrency = () => {
    setTimeout(() => {
      // this.logService.printLog("Searched country - ", this.searchCurrency);
      // this.logService.printLog("Countries filtered list - ", this.currency);
      if (this.searchCurrency !== "") {
        this.currency = this.dataService.currencyList.filter(currency =>
          currency.name.toLowerCase().startsWith(this.searchCurrency.toLowerCase())
        );
      } else {
        this.currency = this.dataService.currencyList;
      }
    }, 200);
  };
  

  closeModal() {
    // this.logService.printLog("Closing modal");
    this.modalRef.close();
    // document.querySelector('body').classList.add('modal-open');    
  }
  open() {
    this.modalRef = this.modalService.open(this.currencyModalContent);
    // this.logService.printLog("Right modal opened");
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/select-currency/select-currency.component.ts